<template>
  <div class="row mr-top">
    <div class="col-md-12">
      <div class="text-center">
        <div v-if="loading">
          <b-spinner style="width: 3rem; height: 3rem;" variant="primary" />
        </div>
        <div v-else>
          <i class="fa fa-check-circle fa-3x" />
          <span class="ct-success">Ihre Bestellung mit der Nummer: {{ orderId }} ist bei uns eingegangen und wird jetzt bearbeitet.</span>
        </div>
      </div>
      <h2>Haben Sie noch Fragen?</h2>
      <h3>Dann schauen Sie gerne auf diesen Seiten nach oder melden Sie sich telefonisch unter: 030 31 00 77 00</h3>

      <ul class="bottom-nav">
        <li><i class="fa fa-check" aria-hidden="true" /><a href="https://www.loewe-zaun.de/faq" target="_blank">Fragen und Antworten</a></li>
        <li><i class="fa fa-check" aria-hidden="true" /><a href="https://www.loewe-zaun.de/liefer-zahlungsbedingungen" target="_blank">Lieferzeiten / Zahlungsbedingungen</a></li>
        <li><i class="fa fa-check" aria-hidden="true" /><a href="https://www.loewe-zaun.de/montageanleitung" target="_blank">Montageanleitung</a></li>
        <li><i class="fa fa-check" aria-hidden="true" /><a href="https://www.loewe-zaun.de/blog" target="_blank">Informativer Zaun-Blog</a></li>
        <li><i class="fa fa-check" aria-hidden="true" /><a href="https://www.loewe-zaun.de/agb" target="_blank">AGB</a></li>
      </ul>
    </div>
  </div>
</template>
<style lang="scss">
    .mr-top {
        margin-top: 55px;

        i {
            color: #5cb85c;
        }

        .ct-success {
            font-weight: 400;
            font-size: 1.125rem;
            margin: 15px 0;
        }
        h2 {
            font-size: 1.125rem;
            font-weight: 600;
            margin-top: 50px;
        }
        h3 {
            font-size: 1.125rem;
            font-weight: 400;
        }
        .bottom-nav {
            margin: 50px 0 0 0;
            padding: 0;

            li {
                list-style: none;
                display: inline-block;
                padding: 0 15px 0 15px;
                font-size: 1.125rem;
            }
            li > a {
                text-decoration: underline;
                cursor: pointer;
            }
            li i {
                color: #1f507c;
                margin: 0px 10px 0 0px;
            }
        }
    }

</style>
<script type="application/javascript">
import { mapGetters } from 'vuex'

export default {
  metaInfo () {
    return { title: 'Bestellstatus' }
  },
  computed: {
    ...mapGetters({
      orderId: 'checkout/orderId',
      loading: 'checkout/orderSending'
    })
  }
}
</script>
